import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import permissions from "app/permissions";
import { SESSIONS, StudentServicePath } from "utils/constants";
import ListAcademicSessions from "./List";
import CreateAcademicSession from "./Create";
import EditAcademicSession from "./Edit";

export const resources = {
  isMenu: true,
  icon: <RunningWithErrorsIcon />,
  title: "Сесии",
  name: StudentServicePath + SESSIONS, //fe path
  list: <ListAcademicSessions onlySessions={true} />,
  create: <CreateAcademicSession />,
  createPermission: permissions.canCreateAcademicSessions,
  edit: <EditAcademicSession />,
  editPermission: permissions.canUpdateAcademicSessions,
  // show: <ShowSessionExam />,
  // showPermission: permissions.canPreviewSessionExams,
  permission: permissions.canPreviewAcademicSessions,
};
